<template>
  <Teleport to="#modalTarget">
    <div class="modal" tabindex="-1" :class="{ 'd-block': show, 'd-none': !show }">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">E-Mail-Adresse ändern</h5>
          <button
            type="button"
            class="btn-close"
            @click="$emit('close')"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
        <div v-if="success" class="alert alert-success">
          E-Mail-Änderung wurde beantragt. Bitte prüfe deine neue E-Mail-Adresse.
          </div>
        <div v-else>
          <p>
            Gib deine neue E-Mail-Adresse ein. Du erhältst eine Bestätigungs-E-Mail an die neue Adresse.
            </p>
            <div class="mb-3">
              <label for="newEmail" class="form-label d-flex align-items-center">
                Neue E-Mail-Adresse 
                <span class="badge bg-danger ms-2">Pflichtfeld</span>
              </label>
              <input
                type="email"
                class="form-control"
                id="newEmail"
                v-model="email"
                placeholder="neue@email.de"
                :class="{ 'is-invalid': emailError }"
                tabindex="101"
              />
              <div v-if="emailError" class="invalid-feedback d-block">
                {{ emailError }}
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('close')"
            tabindex="103"
          >
            {{ success ? 'Schließen' : 'Abbrechen' }}
          </button>
          <button
            v-if="!success"
            type="button"
            class="btn btn-primary"
            @click="handleSubmit"
            :disabled="loading || !isEmailValid"
            tabindex="102"
          >
            {{ loading ? 'Wird gesendet...' : 'E-Mail-Adresse ändern' }}
          </button>
        </div>
      </div>
    </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'submit'])

const email = ref('')
const emailError = ref('')
const error = ref('')
const success = ref(false)
const loading = ref(false)

const isEmailValid = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return email.value && emailRegex.test(email.value)
})

const validateEmail = () => {
  emailError.value = ''
  
  if (!email.value) {
    emailError.value = 'E-Mail-Adresse ist erforderlich'
    return false
  }
  
  if (!isEmailValid.value) {
    emailError.value = 'Ungültige E-Mail-Adresse'
    return false
  }
  
  return true
}

const handleSubmit = async () => {
  if (!validateEmail()) return
  
  loading.value = true
  error.value = ''
  
  try {
    await emit('submit', email.value)
    success.value = true
    
    setTimeout(() => {
      emit('close')
      reset()
    }, 3000)
  } catch (err) {

    console.error('Error in email change:', err)
  } finally {
    loading.value = false
  }
}

const reset = () => {
  email.value = ''
  emailError.value = ''
  error.value = ''
  success.value = false
  loading.value = false
}


watch(() => props.show, (newShow) => {
  if (!newShow) {
    reset()
  }
})


defineExpose({
  setError: (message) => {
    error.value = message
    loading.value = false
  },
  setSuccess: () => {
    success.value = true
    loading.value = false
  },
  setLoading: (state) => {
    loading.value = state
  }
})
</script>
